var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8561 28.9014C25.1039 25.6555 29.9368 23.5157 32.355 22.4818C39.2594 19.5299 40.6941 19.0171 41.6292 19.0002C41.8349 18.9965 42.2947 19.0488 42.5926 19.2973C42.8441 19.5071 42.9133 19.7905 42.9464 19.9894C42.9795 20.1883 43.0208 20.6414 42.988 20.9954C42.6138 25.0363 40.9949 34.8426 40.1713 39.3686C39.8228 41.2836 39.1365 41.9258 38.4722 41.9886C37.0284 42.1252 35.9321 41.0078 34.5337 40.0656C32.3455 38.5912 31.1094 37.6734 28.9854 36.2347C26.5307 34.572 28.122 33.6581 29.5209 32.1646C29.887 31.7738 36.2483 25.8262 36.3714 25.2867C36.3868 25.2192 36.4011 24.9677 36.2557 24.8349C36.1103 24.7021 35.8958 24.7475 35.7409 24.7836C35.5215 24.8348 32.0259 27.2097 25.2541 31.9084C24.2618 32.6088 23.3631 32.95 22.5579 32.9321C21.6702 32.9124 19.9626 32.4162 18.6932 31.9921C17.1362 31.4718 15.8988 31.1968 16.0065 30.3133C16.0627 29.8531 16.6792 29.3824 17.8561 28.9014Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTelegram);
export default __webpack_public_path__ + "static/media/shareTelegram.a4f06ca423c20c47acc2b762dc82347e.svg";
export { ForwardRef as ReactComponent };